// PostOpHealingSection.js
import React from "react";
import { Phone } from "lucide-react";
import postOpHealingImage from "../assets/post-op-healing-image.jpg";

const PostOpHealingSection = () => {
  return (
    <section className="py-16 px-6 md:px-12 lg:px-24 bg-white">
      <div className="max-w-7xl mx-auto">
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
          {/* Left Content */}
          <div>
            <h2 className="text-3xl md:text-4xl lg:text-5xl font-bold text-gray-900 mb-6 leading-tight">
              Post-Operative Care that Promotes Healing and Peace of Mind
            </h2>

            <div className="space-y-4 text-gray-700 font-light leading-relaxed mb-8">
              <p>
                At Allawah Lodge, our post-operative care services are designed
                to help patients recover safely and comfortably at home
                following surgery. We understand that the days after a medical
                procedure can be both physically demanding and emotionally
                overwhelming, which is why our caregivers provide attentive,
                reassuring support every step of the way. From medication
                reminders to mobility assistance, we help you or your loved one
                regain strength and confidence while minimising stress.
              </p>

              <p>
                Our caregivers focus on creating a calm, structured recovery
                environment that allows healing to progress smoothly. We offer
                help with daily routines, meal preparation, personal hygiene,
                and follow-up appointments—ensuring nothing is overlooked during
                this crucial period. Each visit is guided by empathy and
                professionalism, giving families peace of mind knowing that
                their loved one is recovering under caring, watchful support.
              </p>
            </div>

            <a
              href="tel:+61269272706"
              className="inline-flex items-center gap-2 bg-[#E85D2C] hover:bg-[#d54d1f] text-white font-medium px-6 py-3 rounded-full transition-colors"
            >
              <Phone size={20} />
              CALL: (02) 6927 2706
            </a>
          </div>

          {/* Right Image */}
          <div>
            <img
              src={postOpHealingImage}
              alt="Caregiver assisting elderly woman with walker"
              className="w-full h-auto rounded-2xl shadow-lg object-cover"
            />
          </div>
        </div>
      </div>
    </section>
  );
};

export default PostOpHealingSection;
